import { ChangeEvent } from "react"
import { AxSearch } from "@dynata/axiom3"

export interface IProjectSearchProps {
  searchTerm: string
  setSearchTerm: (value: string) => void
}

export function ProjectSearch({
  searchTerm,
  setSearchTerm
}: IProjectSearchProps) {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  }

  return (
    <AxSearch
      id="projects-search" 
      placeholder="Search by Project ID or Order Number"
      value={searchTerm}
      onChange={handleChange}
    />
  )
}